var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var ValidateSuccess = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 26 26", width: "100%", height: "100%" }, props),
        React.createElement("circle", { id: "Oval", fill: color, cx: "13", cy: "13", r: "13" }),
        React.createElement("path", { d: "M9.38700091,19.3992953 C9.78729998,19.7929459 10.3139598,20 10.88279,20 C11.4516202,20 11.97828,19.772111 12.3785791,19.3992953 L20.383808,11.5270224 C21.2053973,10.7190786 21.2053973,9.41390164 20.383808,8.60595785 C19.5622187,7.79801405 18.2349984,7.79801405 17.4134091,8.60595785 L10.8617612,15.0073587 L8.58659087,12.7699759 C7.76500158,11.9620321 6.43778126,11.9620321 5.61619197,12.7699759 C4.79460268,13.5779197 4.79460268,14.8830966 5.61619197,15.6910404 L9.38700091,19.3992953 Z", id: "Path", fill: "#FFFFFF", fillRule: "nonzero" })));
};
ValidateSuccess.defaultProps = {
    color: '#4E9500',
};
export default ValidateSuccess;
//# sourceMappingURL=ValidateSuccess.js.map